export const getTargetActualByProcessStatementResult = (state) => state.processStatement.targetActual;
